import EL, { HTMLELEMENT } from '../../../../../EL/EL.js';
import Selectable, { Deselect, Select } from '../../../../../../interface/Selectable.js';
import { makeAttrStruct } from '../../../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../../../enums/ModelData.js';
// Model Structure
export const optionAttr = makeAttrStruct([
    ['label'],
    ['value'],
    ['disabled'],
    ['selected']
]);
export const optionData = makeDataStruct([
    ['text', ''],
    ['optgroupname']
]);
export const optionModel = makeStruct([
    ['attributes', optionAttr],
    ['data', optionData]
]);
// Simplified Model
export function option(label, value, disabled, selected, optgroupname) {
    return {
        attributes: optionAttr(label, value, disabled, selected),
        data: optionData(optgroupname)
    };
}
/** Represents the model for an <OPTION> for a Select Element */
export default class OPTION extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.OPTION, model);
        this.implement(new Selectable(this));
        this.on('select', () => this.el.setAttribute('selected', 'selected'));
        this.on('deselect', () => this.removeAttribute('selected'));
    }
    setValue(value) {
        this.setData('text', value);
        this.el.value = value;
        return this;
    }
    /** Return the value of this option */
    getValue() {
        return this.getData('text');
    }
    /** Return the label of this option */
    getLabel() {
        return this.getInnerHTML();
    }
}
export { Deselect, EL, Select, Selectable };
